<script setup>
/**
 * FormControlEmailMessageAttachments
 * Lists file attachments for an email message.
 * Opens files from the project-specific Google Cloud Storage bucket.
 */
import { getCurrentInstance } from 'vue';

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    // Attachments are usually read-only, but we define value for contract parity
    value: {
        type: [Object, Array],
        default: () => ({})
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Methods ---

/**
 * Opens the attachment in a new tab.
 * Construct the URL based on the sitename and the GCS object name.
 * @param {string} objectName - The unique storage path/name of the file.
 */
const openFile = (objectName) => {
    const bucket = `creativecms-london--${store.state.sitename}`;
    const url = `https://storage.googleapis.com/${bucket}/${objectName}`;

    window.open(url, '_blank');
};
</script>

<template>
    <div class="list-group">
        <a
            v-for="(fileName, objectName, index) in currentData[field.name]"
            :key="index"
            class="list-group-item list-group-item-action"
            href="#"
            @click.prevent="openFile(objectName)"
        >
            <i class="bi bi-paperclip me-2"></i>
            {{ fileName }}
        </a>
    </div>
</template>

<style scoped>
.list-group-item {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.list-group-item:hover {
    background-color: #f8f9fa;
}
</style>